import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Te levantas "bien" y a media tarde te notas inflada y pesada', 'Has probado dietas, ayuno o "comer limpio" y sigues igual', 'Algunos batidos "saludables" te hinchan más', 'Estás cansada del rebote y de empezar de cero'];
  return <Section background="white" data-id="element-100">
      <div className="text-center mb-8 md:mb-12" data-id="element-101">
        <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#2D2A26] mb-3 md:mb-4" data-id="element-102">
          Si terminas el día con barriga dura… esto es para ti
        </h2>
        <div className="w-24 h-1 bg-[#D4836B] mx-auto rounded-full" data-id="element-103" />
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-104">
        {problems.map((problem, index) => <div key={index} className="flex items-start p-4 md:p-6 bg-[#FAF7F2] rounded-xl border border-[#E8E2DA]" data-id="element-105">
            <XCircle className="h-6 w-6 text-[#D4836B] mt-1 mr-4 flex-shrink-0" data-id="element-106" />
            <p className="text-base md:text-lg text-[#2D2A26] font-medium" data-id="element-107">
              {problem}
            </p>
          </div>)}
      </div>

      <div className="bg-[#F0F4EE] p-5 md:p-8 rounded-2xl text-center max-w-2xl mx-auto" data-id="element-108">
        <p className="text-base md:text-xl text-[#5B7C5B] font-serif italic" data-id="element-109">
          "No te falta voluntad. Te falta un sistema que reduzca disparadores,
          te dé porciones claras y te enseñe a ajustar."
        </p>
      </div>
    </Section>;
}